import React from 'react'
import {Route,Switch} from 'react-router-dom';
import HoroscopeForm from './Layouts/HoroscopeForm'
import ViewHoroscope from './Layouts/ViewHoroscope'

const App=({match})=>{
   
    return (
        <div>
            <Switch>
                <Route exact path={`${match.url}/AddHoroscope`} component={HoroscopeForm}></Route>
                <Route exact path={`${match.url}/ViewHoroscope/`} component={ViewHoroscope}></Route>
            </Switch>
        </div>
    )
}

export default App
